import { render, staticRenderFns } from "./EmployeeInfo.vue?vue&type=template&id=428018d5&scoped=true&"
import script from "./EmployeeInfo.vue?vue&type=script&lang=js&"
export * from "./EmployeeInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428018d5",
  null
  
)

export default component.exports